import PartnerForm from "./PartnerForm.component.jsx";

export default PartnerForm;
